"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteCookie = exports.getCookie = exports.setCookie = void 0;
const cookie_1 = require("cookie");
const setCookie = (cookieName, cookieValue, expireDays) => {
    if (typeof document === 'undefined') {
        return;
    }
    const date = new Date();
    date.setTime(date.getTime() + expireDays * 24 * 60 * 60 * 1000);
    document.cookie = (0, cookie_1.serialize)(cookieName, cookieValue, {
        expires: date,
        path: '/'
    });
};
exports.setCookie = setCookie;
const getCookie = (cookieName) => {
    if (typeof document === 'undefined') {
        return;
    }
    try {
        const cookies = (0, cookie_1.parse)(document.cookie);
        return cookies[cookieName];
    }
    catch (error) {
        console.debug('Error parsing cookies:', error);
        return undefined;
    }
};
exports.getCookie = getCookie;
const deleteCookie = (name) => {
    if (typeof document === 'undefined') {
        return;
    }
    document.cookie = (0, cookie_1.serialize)(name, '', {
        expires: new Date(0),
        path: '/'
    });
};
exports.deleteCookie = deleteCookie;
//# sourceMappingURL=cookie.js.map